import getClients from './getClients'
import getHistoryQuiebras from './getHistoryQuiebras'
import getUbosQuiebras from './getUbosQuiebras'

export const getClientsPromise = getClients
export const getHistoryQuiebrasPromise = getHistoryQuiebras
export const getUbosQuiebrasPromise = getUbosQuiebras
